import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';

const DropdownFilterVastuuhenkilo = ({ options, label, onChange, value, placeholdervastuuhenkilo, ...otherProps }) => {
    const [selectedValue, setSelectedValue] = useState('');

    const selectedOption = useMemo(() => {
        if (!selectedValue) {
            return null;
        }

        return options?.find((option) => option === selectedValue) ?? null;
    }, [options, selectedValue]);

    useEffect(() => {
        if (options.includes(placeholdervastuuhenkilo)) {
            setSelectedValue(placeholdervastuuhenkilo);
            onChange({ target: { name: 'vastuuhenkilo', value: placeholdervastuuhenkilo } });
        } else {
            setSelectedValue(value || ''); // Set the default value if placeholdervastuuhenkilo is not in options
            onChange({ target: { name: 'vastuuhenkilo', value: value || '' } }); // Trigger onChange with default value
        }

    }, [placeholdervastuuhenkilo]);

    const handleChange = (_, newValue) => {
        const nextValue = newValue || '';
        const newValueToSet = nextValue === placeholdervastuuhenkilo ? placeholdervastuuhenkilo : nextValue;
        setSelectedValue(newValueToSet);

        onChange({ target: { name: 'vastuuhenkilo', value: newValueToSet } });
    };

    return (
        <Autocomplete
            options={options || []}
            value={selectedOption}
            onChange={handleChange}
            inputValue={selectedValue}
            onInputChange={(_, newInputValue, reason) => {
                if (reason === 'input') {
                    setSelectedValue(newInputValue);
                }

                if (reason === 'clear') {
                    setSelectedValue('');
                    onChange({ target: { name: 'vastuuhenkilo', value: '' } });
                }
            }}
            freeSolo={false}
            autoHighlight
            clearOnEscape
            getOptionLabel={(option) => option || ''}
            isOptionEqualToValue={(option, currentValue) => option === currentValue}
            noOptionsText='Vastuuhenkilöä ei löytynyt'
            renderInput={(params) => (
                <TextField
                    {...params}
                    {...otherProps}
                    label={label}
                    placeholder='Hae vastuuhenkilöä'
                />
            )}
        />
    );
};

DropdownFilterVastuuhenkilo.propTypes = {
    options: PropTypes.array,
    label: PropTypes.string,
    onChange: PropTypes.func,
    otherProps: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default DropdownFilterVastuuhenkilo;